import { Component, OnInit } from '@angular/core';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { TooltipService } from '../popovers/tooltip/tooltip.service';
import { UsfProductCardInfoBaseComponent } from '../usf-product-card-info/usf-product-card-info-base.component';
import { ListsService } from '@app/lists/services/lists.service';
import { ListsOverlayService } from '@app/lists/services/lists-overlay.service';
import { OrderService } from '@order/services/order.service';
import { ProductAnalyticsService } from '@usf/ngrx-product';

@Component({
  selector: 'app-usf-product-card-non-split',
  templateUrl: './usf-product-card-non-split.component.html',
  styleUrls: ['./usf-product-card-non-split.component.scss'],
})
export class UsfProductCardNonSplitComponent
  extends UsfProductCardInfoBaseComponent
  implements OnInit
{
  constructor(
    platformService: PlatformService,
    panAppState: PanAppState,
    tooltipService: TooltipService,
    listsService: ListsService,
    listsOverlayService: ListsOverlayService,
    readonly orderService: OrderService,
    readonly analyticsService: ProductAnalyticsService,
  ) {
    super(
      platformService,
      panAppState,
      tooltipService,
      listsService,
      listsOverlayService,
      analyticsService,
    );
  }
}
